import { render, staticRenderFns } from "./addProductType.vue?vue&type=template&id=0789b06c&scoped=true&"
import script from "./addProductType.vue?vue&type=script&lang=ts&"
export * from "./addProductType.vue?vue&type=script&lang=ts&"
import style0 from "./addProductType.vue?vue&type=style&index=0&id=0789b06c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789b06c",
  null
  
)

export default component.exports